import React from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import CheckMigrationsForm from './form'

function CheckMigrationsModal ({ open, onClose, target }) {
  return (
    <SydModal
      open={open}
      onClose={onClose}
      title='Check Migrations'
      size='medium'
    >
      {open ? (
        <CheckMigrationsForm target={target} onClose={onClose} />
      ) : null}
    </SydModal>
  )
}

CheckMigrationsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  target: PropTypes.object.isRequired
}

export default CheckMigrationsModal
